import {Checkbox} from "@/components/ui/checkbox";
import {FormControl, FormDescription, FormField, FormItem, FormLabel} from "@/components/ui/form";
import {cn} from "@/lib/utils";


export default function CWFCheckbox({ className, control, name, label, description }) {
    return (
        <FormField
            control={control}
            name={name}
            render={({field}) => (
                <FormItem className={cn("flex flex-row items-start space-x-3 space-y-0 shadow-sm rounded-md border p-4", className)}>
                    <FormControl>
                        <Checkbox
                            checked={field.value}
                            onCheckedChange={field.onChange}
                        />
                    </FormControl>
                    <div className="space-y-1 leading-none">
                        <FormLabel>
                            {label}
                        </FormLabel>
                        {description && <FormDescription>{description}</FormDescription>}
                    </div>
                </FormItem>
            )}
        />

    )
}